import styled from 'styled-components';
import { Heading } from '@zillow/constellation';

const StyledHeading = styled(Heading)`
  /* Needed for IE11. */
  width: 100%;
  text-align: center;
`;

export default StyledHeading;
